import { render, staticRenderFns } from "./studentcp.vue?vue&type=template&id=f4945546&scoped=true&"
import script from "./studentcp.vue?vue&type=script&lang=js&"
export * from "./studentcp.vue?vue&type=script&lang=js&"
import style0 from "./studentcp.vue?vue&type=style&index=0&id=f4945546&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4945546",
  null
  
)

export default component.exports